<template>
  <div :class="cardStyles" class="mb-8 p-6 duration-300">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
        <vx-card>
          <h2 class="mt-0 text-primary">Your Selected Car</h2>
          <vs-divider></vs-divider>

          <img :src="item.VehicleGroup.ImageURL" alt="content-img" class="responsive card-img-top">

          <div class="w-full">
            <h4 class="text-lg font-bold py-4">
              {{ item.VehicleGroup.ShortDescription }}
            </h4>

            <div class="grid col-span-2" style="display: grid; grid-template-columns: auto auto">
              <div class="flex p-1" v-if="item.VehicleGroup.Passengers">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M16.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M18 6A6 6 0 1 0 6 6a6 6 0 0 0 12 0M3 23.25a9 9 0 1 1 18 0 .75.75 0 0 0 1.5 0c0-5.799-4.701-10.5-10.5-10.5S1.5 17.451 1.5 23.25a.75.75 0 0 0 1.5 0">
                  </path>
                </svg>
                <p>Capacity: {{ item.VehicleGroup.Passengers }} seats</p>
              </div>

              <div class="flex p-1" v-if="item.VehicleGroup.Transmition">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M19.25 14.25v-4.5l-1.374.416 3 4.5c.412.617 1.374.326 1.374-.416v-4.5a.75.75 0 0 0-1.5 0v4.5l1.374-.416-3-4.5c-.412-.617-1.374-.326-1.374.416v4.5a.75.75 0 0 0 1.5 0m3 6a3.75 3.75 0 0 0-3.75-3.75.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75a3.75 3.75 0 0 0 3.75-3.75m-1.5 0a2.25 2.25 0 0 1-2.25 2.25l.75.75v-6l-.75.75a2.25 2.25 0 0 1 2.25 2.25M18.5 4.5H20A2.25 2.25 0 0 0 20 0h-1.5a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 1.5 0v-6l-.75.75H20A.75.75 0 0 1 20 3h-1.5a.75.75 0 0 0 0 1.5M4.25 6.75v4.5A2.25 2.25 0 0 0 6.5 13.5H8a.75.75 0 0 1 .75.75v4.5A2.25 2.25 0 0 0 11 21h3a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 1-.75-.75v-4.5A2.25 2.25 0 0 0 8 12H6.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-1.5 0m3-3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m1.5 0a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0">
                  </path>
                </svg>
                <p>Transmission: {{ item.VehicleGroup.Transmition }}</p>
              </div>

              <div class="flex p-1" v-if="item.VehicleGroup.Luggages">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M22.5 14.249v4.5a2.25 2.25 0 0 1-2.25 2.25H3.75a2.25 2.25 0 0 1-2.25-2.25v-9a2.25 2.25 0 0 1 2.25-2.25h16.5a2.25 2.25 0 0 1 2.25 2.25zm1.5 0v-4.5a3.75 3.75 0 0 0-3.75-3.75H3.75A3.75 3.75 0 0 0 0 9.749v9a3.75 3.75 0 0 0 3.75 3.75h16.5a3.75 3.75 0 0 0 3.75-3.75zm-18-7.5v15a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0m10.5 0v15a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0m0 0v-3a2.25 2.25 0 0 0-2.25-2.25h-4.5a2.25 2.25 0 0 0-2.25 2.25v3a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 0 1.5 0">
                  </path>
                </svg>
                <p>Large Bag: {{ item.VehicleGroup.Luggages }} </p>
              </div>

              <div class="flex p-1" v-if="item.VehicleGroup.SmallLuggages">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M15 14.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5m.75 3.25a.76.76 0 0 0-.75-.75H9a.75.75 0 0 0 0 1.5h6a.76.76 0 0 0 .75-.75m3-6.5v9a2.25 2.25 0 0 1-2.25 2.25h-.75v.5a.75.75 0 0 1-1.5 0v-.5h-4.5v.5a.75.75 0 0 1-1.5 0v-.5H7.5a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 7.5 9.25h1.75v-8C9.25.56 9.81 0 10.5 0h3c.69 0 1.25.56 1.25 1.25v8h1.75a2.25 2.25 0 0 1 2.25 2.25m-8-2.25h2.5V1.5h-2.5zm6.5 2.25a.76.76 0 0 0-.75-.75h-9a.76.76 0 0 0-.75.75v9a.76.76 0 0 0 .75.75h9a.76.76 0 0 0 .75-.75z">
                  </path>
                </svg>
                <p>Small Bag : {{ item.VehicleGroup.SmallLuggages }}</p>
              </div>


              <div class="flex p-1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 mr-2" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path
                    d="M16 4V2a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2h1.5a3.5 3.5 0 0 0 3.5-3.5v-5.92a3.5 3.5 0 0 0-1.03-2.47l-3.17-3.17A1 1 0 0 0 16 7.17V4zm-2 0h-8v16h8zm-1 2v4h-6V6zm3.75 6.09v-3.4l2.09 2.09h-1.59a.5.5 0 0 0-.5.5zm-.75 6.91H16v-4h2v1.5a1.5 1.5 0 0 1-1.5 1.5z" />
                </svg>

                <p>Fuel Type : {{ item.VehicleGroup.FuelType }} </p>
              </div>
            </div>
          </div>
        </vx-card>
        <vs-divider v-if="calculateUpgradeCost() > 0">UPGRADE AVAILABLE</vs-divider>
        <vx-card v-if="calculateUpgradeCost() > 0">
          <h2 class="mt-0 text-primary">Why Not Upgrade for only RM {{ calculateUpgradeCost() }}</h2>
          <vs-divider></vs-divider>
          <img :src="carUpgrade.VehicleGroup.ImageURL" alt="content-img" class="responsive card-img-top">
          <div class="w-full">
            <h4 class="text-lg font-bold py-4">
              {{ carUpgrade.VehicleGroup.ShortDescription }}
            </h4>

            <div class="grid col-span-2" style="display: grid; grid-template-columns: auto auto">
              <div class="flex p-1" v-if="carUpgrade.VehicleGroup.Passengers">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M16.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M18 6A6 6 0 1 0 6 6a6 6 0 0 0 12 0M3 23.25a9 9 0 1 1 18 0 .75.75 0 0 0 1.5 0c0-5.799-4.701-10.5-10.5-10.5S1.5 17.451 1.5 23.25a.75.75 0 0 0 1.5 0">
                  </path>
                </svg>
                <p>Capacity: {{ carUpgrade.VehicleGroup.Passengers }} seats</p>
              </div>

              <div class="flex p-1" v-if="carUpgrade.VehicleGroup.Transmition">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M19.25 14.25v-4.5l-1.374.416 3 4.5c.412.617 1.374.326 1.374-.416v-4.5a.75.75 0 0 0-1.5 0v4.5l1.374-.416-3-4.5c-.412-.617-1.374-.326-1.374.416v4.5a.75.75 0 0 0 1.5 0m3 6a3.75 3.75 0 0 0-3.75-3.75.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75a3.75 3.75 0 0 0 3.75-3.75m-1.5 0a2.25 2.25 0 0 1-2.25 2.25l.75.75v-6l-.75.75a2.25 2.25 0 0 1 2.25 2.25M18.5 4.5H20A2.25 2.25 0 0 0 20 0h-1.5a.75.75 0 0 0-.75.75v6a.75.75 0 0 0 1.5 0v-6l-.75.75H20A.75.75 0 0 1 20 3h-1.5a.75.75 0 0 0 0 1.5M4.25 6.75v4.5A2.25 2.25 0 0 0 6.5 13.5H8a.75.75 0 0 1 .75.75v4.5A2.25 2.25 0 0 0 11 21h3a.75.75 0 0 0 0-1.5h-3a.75.75 0 0 1-.75-.75v-4.5A2.25 2.25 0 0 0 8 12H6.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-1.5 0m3-3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m1.5 0a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0">
                  </path>
                </svg>
                <p>Transmission: {{ carUpgrade.VehicleGroup.Transmition }}</p>
              </div>

              <div class="flex p-1" v-if="carUpgrade.VehicleGroup.Luggages">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M22.5 14.249v4.5a2.25 2.25 0 0 1-2.25 2.25H3.75a2.25 2.25 0 0 1-2.25-2.25v-9a2.25 2.25 0 0 1 2.25-2.25h16.5a2.25 2.25 0 0 1 2.25 2.25zm1.5 0v-4.5a3.75 3.75 0 0 0-3.75-3.75H3.75A3.75 3.75 0 0 0 0 9.749v9a3.75 3.75 0 0 0 3.75 3.75h16.5a3.75 3.75 0 0 0 3.75-3.75zm-18-7.5v15a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0m10.5 0v15a.75.75 0 0 0 1.5 0v-15a.75.75 0 0 0-1.5 0m0 0v-3a2.25 2.25 0 0 0-2.25-2.25h-4.5a2.25 2.25 0 0 0-2.25 2.25v3a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v3a.75.75 0 0 0 1.5 0">
                  </path>
                </svg>
                <p>Large Bag: {{ carUpgrade.VehicleGroup.Luggages }} </p>
              </div>

              <div class="flex p-1" v-if="carUpgrade.VehicleGroup.SmallLuggages">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24">
                  <path
                    d="M15 14.75H9a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5m.75 3.25a.76.76 0 0 0-.75-.75H9a.75.75 0 0 0 0 1.5h6a.76.76 0 0 0 .75-.75m3-6.5v9a2.25 2.25 0 0 1-2.25 2.25h-.75v.5a.75.75 0 0 1-1.5 0v-.5h-4.5v.5a.75.75 0 0 1-1.5 0v-.5H7.5a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 7.5 9.25h1.75v-8C9.25.56 9.81 0 10.5 0h3c.69 0 1.25.56 1.25 1.25v8h1.75a2.25 2.25 0 0 1 2.25 2.25m-8-2.25h2.5V1.5h-2.5zm6.5 2.25a.76.76 0 0 0-.75-.75h-9a.76.76 0 0 0-.75.75v9a.76.76 0 0 0 .75.75h9a.76.76 0 0 0 .75-.75z">
                  </path>
                </svg>
                <p>Small Bag : {{ carUpgrade.VehicleGroup.SmallLuggages }}</p>
              </div>


              <div class="flex p-1">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 mr-2" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path
                    d="M16 4V2a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2h1.5a3.5 3.5 0 0 0 3.5-3.5v-5.92a3.5 3.5 0 0 0-1.03-2.47l-3.17-3.17A1 1 0 0 0 16 7.17V4zm-2 0h-8v16h8zm-1 2v4h-6V6zm3.75 6.09v-3.4l2.09 2.09h-1.59a.5.5 0 0 0-.5.5zm-.75 6.91H16v-4h2v1.5a1.5 1.5 0 0 1-1.5 1.5z" />
                </svg>

                <p>Fuel Type : {{ carUpgrade.VehicleGroup.FuelType }} </p>
              </div>
            </div>
            <vs-button @click="handelViewDeal($store.state.main.carUpgrade)" type="gradient" class="w-full mt-6"
              color="#7367F0" gradient-color-secondary="#CE9FFC">UPGRADE NOW</vs-button>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
        <vx-card>
          <h2 class="mt-0 text-primary">Recommended additional services</h2>
          <vs-divider></vs-divider>
          <div class="w-full">
            <h3 class="text-primary"><strong>Equipment</strong></h3>
            <div class="boosterSeat pl-10">
              <extras :filter="['BOST', 'BSEAT']"></extras>
              <!-- <extras :filter="['BOST','BSEAT','PAI','SCDW','ADDRV','ADFLEE','IFEE','OWH','WAFEE']"></extras> -->
            </div>

            <h3 class="text-primary"><strong>Damage Waiver</strong></h3>
            <vs-alert active="true" icon-pack="feather" icon="icon-info">
              If the rental car is damaged, you may be responsible for an excess fee. By purchasing CDW (Collision
              Damage Waiver), 50% of this fee will be covered. With SCDW (Super Collision Damage Waiver), 100% of the
              fee will be covered, leaving no financial responsibility for you."
            </vs-alert>
            <div class="boosterSeat pl-10">
              <extras :filter="['CDW', 'SCDW']" label="each per day"></extras>
              <extras :filter="['PAI', ]" label="each per day"></extras>
            </div>

            <h3 class="text-primary"><strong>Others</strong></h3>
            <div class="boosterSeat pl-10">
              <extras :filter="['ADDRV']"></extras>
            </div>

          </div>

        </vx-card>
      </div>
    </div>
<!--
    $store.state.main.carUpgrade
    <pre>{{ $store.state.main.carUpgrade }}</pre> -->
  </div>
</template>

<script>
import { axiosMixin } from "@/mixin/axiosMixin";
import extras from "@/components/hawk/extras.vue";
export default {
  components: {
    extras,
  },
  mixins: [axiosMixin],
  props: {
    item: {
      required: true,
    },
    showButtonAndPrice: {
      type: Boolean,
      default: false,
    },
    cardStyles: {
      type: String,
      default: "bg-white rounded-lg shadow hover:shadow-lg",
    },
  },
  computed: {
    carUpgrade() {
      return this.$store.state.main.carUpgrade;
    },
  },
  methods: {
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    handelViewDeal(carDetails) {
      console.log('car details:', carDetails);
      console.log('booking details:', this.$store.state.main.bookingDetails);


      this.startLoading();
      var params = {
        dateFrom: this.$store.state.main.bookingDetails.formData.pickupDate,
        dateTo: this.$store.state.main.bookingDetails.formData.dropoffDate,
        pickupplace: this.$store.state.main.bookingDetails.formData.pickupPlace,
        dropoffplace: this.$store.state.main.bookingDetails.formData.dropOffPlace,
        vehiclegroup: carDetails.VehicleGroup.Group,
        pm: 'local'
      }
      this.aronPost('getExtras', params, '', '')
        .then(response => {
          if (response.status) {
            var extras = response.data.extras;
            for (let i = 0; i < extras.length; i++) {
              extras[i].Quantity = 0;
            }
            this.$store.state.main.extras = extras;
            this.$store.state.main.currentCarSelected = carDetails;
            this.$router.push("/carDetails").catch(() => { });
          } else {
            this.errorAlert('Error', response.data.error);
          }

          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        });

      this.$store.state.main.carUpgrade = this.getVehicleGroupByGroup(carDetails.VehicleGroup.UpgradeTo);

    },
    getVehicleGroupByGroup(group) {
      // Access the array from the store
      const vehicleGroups = this.$store.state.main.vehicleGroup;

      // Use the `find` method to search for the specific group
      const result = vehicleGroups.find(vehicle => vehicle.VehicleGroup.Group === group);

      // Return the result (or null if not found)
      return result || null;
    },

    calculateUpgradeCost() {
      const currentCar = this.$store.state.main.currentCarSelected;
      const upgradeCar = this.$store.state.main.carUpgrade;

      if (!currentCar || !upgradeCar) {
        console.warn("Current car or upgrade car details are not available.");
        return 0; // Fallback if data is not available
      }

      // Extract the UnitAmount for both cars
      const currentCarAmount = currentCar.Charges.Calculation.TotalAmount;
      const upgradeCarAmount = upgradeCar.Charges.Calculation.TotalAmount;

      // Calculate the additional cost for the upgrade
      const additionalCost = upgradeCarAmount - currentCarAmount;

      return additionalCost;
    }
  },
};
</script>

<style scoped></style>
